import React from 'react';

const CabPageShell = ({ title, description }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
    <p className="text-xs uppercase tracking-[0.2em] text-emerald-600">Cab Services</p>
    <h1 className="mt-2 text-2xl font-semibold text-slate-900">{title}</h1>
    <p className="mt-2 text-sm text-slate-600">{description}</p>
    <div className="mt-6 rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-sm text-slate-500">
      This section is available and ready for configuration. No records or custom workflows have been added here yet.
    </div>
  </div>
);

export default CabPageShell;
